const RootPath = window.g.baseUrl
const apis = {
  /* 员工 */
  // 获取员工列表
  getEmployees: RootPath + 'plugin/organization/employee/index',
  // 获取单个员工信息
  getEmployee: RootPath + 'plugin/organization/employee/getForm',
  // 保存
  saveEmployee: RootPath + 'plugin/organization/employee/save',
  // 删除
  delEmployees: RootPath + 'plugin/organization/employee/delBatches',
  delEmployeeFiles: RootPath + 'plugin/organization/employee/delAttaches',

  /* 部门 api */
  // 获取没有在当前部门的成员列表
  getEmployeesForDepartment: RootPath + 'plugin/organization/department/getEmployees',
  // 获取部门列表
  getDepartments: RootPath + 'plugin/organization/department/index',
  // 获取部门从表
  getDepartment: RootPath + 'plugin/organization/department/getForm',
  // 获取部门从表明细
  // getDepartmentEmployees: RootPath + 'plugin/organization/department/getEmployees',
  // 保存整个客户
  saveDepartment: RootPath + 'plugin/organization/department/save',
  // 保存客户主表
  saveDepartmentMain: RootPath + 'plugin/organization/department/saveMain',
  // 保存客户联系人从表明细
  saveDepartmentDetails: RootPath + 'plugin/organization/department/saveDetails',
  // 删除客户
  delDepartments: RootPath + 'plugin/organization/department/delBatches',
  // 删除客户联系人从表明细
  delDepartmentEmployees: RootPath + 'plugin/organization/department/delEmployees',

  /* 职务 api */
  // 获取职务列表
  getPositions: RootPath + 'plugin/organization/position/index',
  // 根据职务ID获取职务
  getPosition: RootPath + 'plugin/organization/position/getForm',
  // 职务保存
  savePosition: RootPath + 'plugin/organization/position/save',
  // 批量删除职务
  delPositions: RootPath + 'plugin/organization/position/delBatches',
  // 获取可以移库的库位
  getAvaliablePosition: RootPath + 'plugin/plate/packagenote/GetAvaliablePosition',
  // 更新移库库存
  updateAvaliablePosition: RootPath + 'plugin/plate/packagenote/UpdateAvaliablePosition',
}

export default apis
